import { render, staticRenderFns } from "./CompanySubscribersList.vue?vue&type=template&id=84ffa59e"
import script from "./CompanySubscribersList.vue?vue&type=script&lang=ts"
export * from "./CompanySubscribersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports